import { CommonCatalogService } from '@savgroup-front-common/core/api/Catalog';

import getAsKeysByModelTypeQuery from './getAsKeysByModelTypeQuery';
import getAssemblingModelsBySkusCommand from './getAssemblingModelsBySkusCommand';
import getBrandGeneric from './getBrandGeneric';
import getModelByIdQuery from './getModelByIdQuery';
import getModelTypeGeneric from './getModelTypeGeneric';
import getModelTypesTreeBySellerIdsQuery from './getModelTypesTreeBySellerIdsQuery';
import getRepairableByModelId from './getRepairableByModelId';
import upsertModelCommand from './upsertModelCommand';

export const CatalogService = {
  getModelTypesTreeBySellerIdsQuery,
  getModelByIdQuery,
  getRepairableByModelId,
  getAssemblingModelsBySkusCommand,
  getModelTypeGeneric,
  getBrandGeneric,
  recognizeSerialNumberCommand:
    CommonCatalogService.recognizeSerialNumberCommand,
  getAsKeysByModelTypeQuery,
  upsertModelCommand,
};
